import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import TextInput from "./TextInput";

export const QuoteForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const serviceID = "default_service";
    const templateID = "template_a1b49i6";
    emailjs
      .sendForm(serviceID, templateID, form.current, "bNEXSmDnhQYO3tppu")
      .then(
        (result) => {
          alert("sent!");
          console.log(result, form.current);
        },
        (error) => {
          alert(error.text);

          console.log(error.text);
        }
      );
  };

  return (
    <form className="space-y-8 text-white" ref={form} onSubmit={sendEmail}>
      <div className=" grid gap-4 overflow-hidden sm:grid-cols-2 sm:gap-6">
        <TextInput
          label={"Business / Brand Name:"}
          placeHolder={"Business / Brand Here."}
          type={"text"}
          nameOfInput={"brandName"}
          size={"w-full"}
        />
        <TextInput
          label={"Your Name:"}
          placeHolder={"Your Name Here."}
          type={"text"}
          nameOfInput={"userName"}
          size={"w-full"}
        />
        <TextInput
          label={"Email:"}
          placeHolder={"Email Here."}
          type={"email"}
          nameOfInput={"userEmail"}
          size={"w-full"}
        />
        <TextInput
          label={"Phone:"}
          placeHolder={"Phone Here."}
          type={"tel"}
          nameOfInput={"userPhone"}
          size={"w-full"}
        />
        <TextInput
          label={"Service Needed?"}
          placeHolder={
            "Logo/Graphic Design, Embroidery, Decals/Banners, Heat Transfer, Promo Items, etc... "
          }
          type={"text"}
          nameOfInput={"serviceNeeded"}
          size={"sm:col-span-2"}
        />

        {/*                         -------------------       description block          ----------------------*/}

        <div className="overflow-hidden sm:col-span-2">
          <label
            htmlFor="description"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Description.
          </label>
          <textarea
            name="message"
            rows="8"
            className="block p-2.5 w-full text-sm text-black bg-grey  focus:ring-primary-500 focus:border-primary-500"
            placeholder="Your Description Here."
          ></textarea>
        </div>
        {/*                         -------------------       description block         ----------------------*/}
        <TextInput
          label={"What Does Your Business Do?"}
          placeHolder={"What Products Or Services Do You Offer?"}
          type={"text"}
          nameOfInput={"businessModel"}
          size={"sm:col-span-2"}
        />
        <TextInput
          label={"Slogan Or Tagline?"}
          placeHolder={"If You Have a Tagline Please Enter It Here."}
          type={"text"}
          nameOfInput={"tagline"}
          size={"sm:col-span-2"}
        />
      </div>
      <div className="w-full flex justify-center pt-10">
        <button
          type="Submit"
          className="py-3 px-5 text-sm text-black text-center border border-black  bg-primary sm:w-fit hover:bg-secondary hover:text-white focus:ring-4 focus:outline-none focus:ring-primary-300"
        >
          Submit
        </button>
      </div>
    </form>
  );
};
